export default "__VITE_ASSET__CTiNZATH__"